import React from 'react';
import AwsJsonTable from '../../../../common/components/AwsJsonTable';
import { fillWithEmptyValues } from '../../../../../common/utils';
import { priceColumns, priceRows } from './awsjson.price.js';
import { clone } from 'ramda';


const Price = (props) =>  {
  const { data, onChange } = props,
        d = fillWithEmptyValues(data, priceColumns, 'key', priceRows);

  const handlePriceChange = (e, { name, value, ix }) => {
    const price = clone(d);
    price[ix][name] = value;

    onChange(e, { name: 'price', value: price});
  };
  
  return (
    <AwsJsonTable
      data={d}
      cols={priceColumns}
      rowCount={priceRows}
      onChange={handlePriceChange}
    />
  );
};

export default Price;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Panes/Price.js